export default {"src":"https://fishbrain.com/_next/static/media/wave1.60b0f60d.svg","height":23,"width":769,"blurWidth":0,"blurHeight":0};